import { DirectSalesSpreadsheetType } from '@/modules/direct-sales/enums/direct-sales-spreadsheet.enum';
import { DirectSalesSpreadsheetFarmer } from '@/modules/direct-sales/services/direct-sales-spreadsheet/direct-sales-spreadsheet-farmer';

export class DirectSalesSpreadsheetFactory {
  static get(type: DirectSalesSpreadsheetType, dataSource: any[]) {
    switch (type) {
      case DirectSalesSpreadsheetType.Farmer:
        return new DirectSalesSpreadsheetFarmer().mount(dataSource);
      default:
        throw new Error('Unknown type');
    }
  }
}
